import { render } from "./SupportView.vue?vue&type=template&id=57df8139&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=57df8139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57df8139"]])

export default __exports__